/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPInvestigation from './intra-op-investigation';
import IntraOPInvestigationDetail from './intra-op-investigation-detail';
import IntraOPInvestigationUpdate from './intra-op-investigation-update';
import IntraOPInvestigationDeleteDialog from './intra-op-investigation-delete-dialog';

const IntraOPInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPInvestigation />} />
    <Route path="new" element={<IntraOPInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPInvestigationDetail />} />
      <Route path="edit" element={<IntraOPInvestigationUpdate />} />
      <Route path="delete" element={<IntraOPInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPInvestigationRoutes;
